module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav-mobile show-sm",
    attrs: {
      "role": "navigation"
    }
  }, [_c('a', {
    staticClass: "nav-mobile__close",
    attrs: {
      "href": "#",
      "id": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav--block nav--primary"
  }, [_c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('')
    }
  }, [_vm._v("หน้าแรก")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('router-link', {
    staticClass: "nav__link",
    attrs: {
      "to": "/special-events"
    }
  }, [_vm._v("เพจระดมเงิน")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('our-work')
    }
  }, [_vm._v("งานของเรา")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('about')
    }
  }, [_vm._v("เกี่ยวกับเรา")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('good-governance')
    }
  }, [_vm._v("ธรรมาภิบาล")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('take-action')
    }
  }, [_vm._v("ร่วมร้อยพลัง")])])]), _vm._v(" "), (!_vm.isLoggedIn) ? _c('ul', {
    staticClass: "nav nav--inline nav--secondary"
  }, [_c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$loginModal.show()
      }
    }
  }, [_vm._v("เข้าสู่ระบบ")])])]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
    ref: "dropdown",
    staticClass: "nav nav--block nav--secondary show-sm"
  }, [_c('div', {}, [_c('ul', {
    staticClass: "nav is-loggedin"
  }, [_c('li', {
    staticClass: "nav__item"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('router-link', {
    staticClass: "nav__link",
    attrs: {
      "to": "/user/pages"
    }
  }, [_vm._v("กองผ้าป่าของฉัน")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('router-link', {
    staticClass: "nav__link",
    attrs: {
      "to": "/user/profile"
    }
  }, [_vm._v("แก้ไขข้อมูลส่วนตัว")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('router-link', {
    staticClass: "nav__link",
    attrs: {
      "to": "/user/logout"
    }
  }, [_vm._v("ออกจากระบบ")])], 1)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64095531","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavMenu.vue
// module id = 1179
// module chunks = 0